import { render } from "./edit-teacher-profile.vue?vue&type=template&id=504eb2da&ts=true"
import script from "./edit-teacher-profile.vue?vue&type=script&lang=ts"
export * from "./edit-teacher-profile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__